import { render, staticRenderFns } from "./serviceDeposit.vue?vue&type=template&id=fc31c9a0&scoped=true&"
import script from "./serviceDeposit.vue?vue&type=script&lang=js&"
export * from "./serviceDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc31c9a0",
  null
  
)

export default component.exports